export default {
      id: "ind-transparent-tick-usage",
      viewBox: "0 0 29 29",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#ind-transparent-tick",
      toString: function () {
        return this.url;
      }
    }